'use client'

import Link from 'next/link'
import { useScrollDirection } from '@/hooks/useScrollDirection'
import useCommonStore from '@/store/commonStore'
import useCartStore from '@/store/cartStore'



export function MobileFooter() {
	const { translations } = useCommonStore()
    const { cart } = useCartStore()


	const navigationItems = [
		{
			name: translations["home"] || "Home",
			href: '/',
			icon: `${process.env.NEXT_PUBLIC_ICON_URL}a0a8cedf-2d4c-4e35-bca8-6119279615c9.svg`,
			isActive: true
		},
		{
			name: translations["store"]||"Store",
			href: '/products',
			icon: `${process.env.NEXT_PUBLIC_ICON_URL}bed85fef-084a-4395-b57d-5d80ed0a007c.svg`,
			isActive: false
		},
		{
			name: translations["categories"]|| "Categories",
			href: '/categories',
			icon: `${process.env.NEXT_PUBLIC_ICON_URL}8fe5d5ec-09eb-4e5d-8743-c1deb426f3de.svg`,
			isActive: false
		},
		// {
		// 	name: translations["blogs"]||"Blog",
		// 	href: 'https://blog.curlified.com',
		// 	icon: `${process.env.NEXT_PUBLIC_ICON_URL}b5fd97d8-0e60-445b-bcb3-463e29dc1266.svg`,
		// 	isActive: false
		// },
		{
			name: translations["cart"]||"Cart",
			href: '/mycart',
			icon: `${process.env.NEXT_PUBLIC_ICON_URL}0a8ba191-916a-4574-b070-0e455926d01c.svg`,
			isActive: false,
			showBagItems:true

		},
		{
			name: translations["profile"]||"Profile",
			href: '/profile',
			icon: `${process.env.NEXT_PUBLIC_ICON_URL}b5fd97d8-0e60-445b-bcb3-463e29dc1266.svg`,
			isActive: false
		}
	]

	return (
		<footer
			className={`fixed bottom-0 left-0 right-0 z-50 bg-white border-t md:hidden transition-transform duration-300 h-[70px] p-4 flex justify-between items-center`}
		>
			{navigationItems.map((item) => (
			<div key={item.name} className='relative'>
					<Link
					
					href={item.href}
					className="flex flex-col items-center justify-center gap-1 min-w-[64px]"
				>
					<img src={item.icon} alt={`${item.name} icon`} className='w-5 h-5' />
					<span
						className={`text-[10px] ${item.isActive
							? 'text-primary font-bold'
							: ''
							}`}
					>
						{item.name}
					</span>
					{item?.showBagItems && cart?.length > 0 && (
						<span className="absolute -top-1 right-4 bg-red-500 text-white text-xs rounded-full min-w-[14px] h-[14px] flex items-center justify-center text-[10px]">
							{cart?.length}
						</span>
					)}
				</Link>
			</div>
			))}
		</footer>
	)
}